import React from 'react';
import './ButtomLayout.css';
import { useNavigate } from 'react-router-dom';

const RealEstateLayout = () => {
  const projectData = {
    title: "Life Valley Project",
    location: "The privileged location in Lambeth region in the west of London city.",
    description: "The project is close to many hotels, hospitals and commercial centers...",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80"
  };
  const navigate = useNavigate();

  return (
    <div className="container">
      {/* Search Banner */}
      <section className="search-banner">
        <div className="banner-content">
          <h1>Search Your Dream House On The Map</h1>
          <p>Find the house you are looking for easily according to location information.</p>
          <button className="btn-primary">Search On Map</button>
        </div>
        <div className="banner-image">
          <img src="https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&w=800&q=80" alt="Phone Map" />
        </div>
      </section>

      {/* Featured Projects Header */}
      <div className="section-header">
        <h2>Featured Projects</h2>
        <button className="btn-all" onClick={()=>navigate("/search-results")}>All</button>
      </div>

      {/* Large Featured Card */}
      <div className="featured-card-large">
        <div className="card-content">
          <h3>{projectData.title}</h3>
          <p className="location">{projectData.location}</p>
          <p className="description">{projectData.description}</p>
          <button className="btn-outline" onClick={()=>navigate("/rental-details")}>View Project</button>
        </div>
        <div className="card-image">
          <img src={projectData.image} alt="City Buildings" />
        </div>
      </div>

      {/* Small Project Grid */}
      <div className="project-grid">
        {[1, 2].map((item) => (
          <div key={item} className="featured-card-small">
            <div className="card-content">
              <h3>{projectData.title}</h3>
              <p className="location">{projectData.location}</p>
              <p className="description">{projectData.description}</p>
              <button className="btn-outline"  onClick={()=>navigate("/rental-details")}>View Project</button>
            </div>
            <div className="card-image">
              <img src={projectData.image} alt="City Buildings" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RealEstateLayout;